// 字典
const dictionary = {
  ModificationSuccessful: {
    zh: '修改成功',
    en: 'Modification successful',
    pu: 'Modificação bem sucedida'
  },
  pleaseChoose: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Favor selecionar'
  },
  pleaseInput: {
    zh: '请输入',
    en: 'Please enter',
    pu: 'por favor digite'
  },
  inputNum: {
    zh: '请输入数字',
    en: 'Please enter a number',
    pu: 'Favor digitar o número'
  },
  notNull: {
    zh: '不能为空',
    en: 'Cannot be empty',
    pu: 'Não pode estar vazio'
  },
  dictionaryList: {
    zh: '字典列表',
    en: 'Dictionary List',
    pu: 'lista do dicionário'
  },
  dictionaryCode: {
    zh: '字典代码',
    en: 'Dictionary Code',
    pu: 'código de dicionário'
  },
  dictionaryValue: {
    zh: '字典值',
    en: 'Dictionary Value',
    pu: 'valor do dicionário'
  },
  search: {
    zh: '查询',
    en: 'Search',
    pu: 'consultar'
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    pu: 'Resetar'
  },
  dictionaryType: {
    zh: '字典类型',
    en: 'Dictionary Type',
    pu: 'tipo do dicionário'
  },
  dictionaryT: {
    zh: '字典类型',
    en: 'Dictionary Type',
    pu: 'tipo do dicionário'
  },
  dictionaryC: {
    zh: '字典代码',
    en: 'Dictionary Code',
    pu: 'código do dicionário'
  },
  dictionaryName: {
    zh: '字典名称',
    en: 'Dictionary Name',
    pu: 'nome do dicionário'
  },
  dictionaryN: {
    zh: '字典名称',
    en: 'Dictionary Name',
    pu: 'nome do dicionário'
  },
  dictionaryV: {
    zh: '字典值',
    en: 'Dictionary Value',
    pu: 'valor do dicionário'
  },
  CreationTime: {
    zh: '创建时间',
    en: 'Creation time',
    pu: 'tempo de criação'
  },
  CreationT: {
    zh: '创建时间',
    en: 'Creation time',
    pu: 'tempo de criação'
  },
  ModificationTime: {
    zh: '修改时间',
    en: 'Modification time',
    pu: 'Tempo de modificação'
  },
  ModificationT: {
    zh: '修改时间',
    en: 'Modification time',
    pu: 'Tempo de modificação'
  },
  DictionaryMultilingualList: {
    zh: '字典多语言列表',
    en: 'Dictionary Multilingual List',
    pu: 'Lista multilíngue de dicionário'
  },
  DictionaryEnumerationValue: {
    zh: '字典枚举值',
    en: 'Dictionary Enumeration Value',
    pu: 'Valor de enumeração do dicionário'
  },
  language: {
    zh: '语言',
    en: 'Language',
    pu: 'idioma'
  },
  add: {
    zh: '新增',
    en: 'Add',
    pu: 'Novo'
  },
  modify: {
    zh: '修改',
    en: 'Modify',
    pu: 'modificar'
  },
  newAddSuc: {
    zh: '新增成功',
    en: 'Added successfully',
    pu: 'adicionar com sucesso'
  },
  DictionaryEnumerationV: {
    zh: '字典枚举值',
    en: 'Dictionary Enumeration Value',
    pu: 'Valor de enumeração do dicionário'
  },
  yuyan: {
    zh: '语言',
    en: 'Language',
    pu: 'idioma'
  },
  describe: {
    zh: '描述',
    en: 'Description',
    pu: 'descrição'
  },
  description: {
    zh: '描述',
    en: 'Description',
    pu: 'descrição'
  },
  operation: {
    zh: '操作',
    en: 'Operation',
    pu: 'Operação'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'editar'
  },
  submit: {
    zh: '提交',
    en: 'Submit',
    pu: 'submeter'
  },
  detail: {
    zh: '详情',
    en: 'Detail',
    pu: 'detalhe'
  },
  pleaseInputNumber: {
    zh: '请输入数字类型',
    en: 'Please enter a number',
    pu: 'Por favor, digite o tipo de número'
  },
  // ===== 新字典系统 =====
  newDictType: {
    zh: '字典类型',
    en: 'Dictionary Type',
    pu: 'Tipo de Dicionário'
  },
  isSystem: {
    zh: '系统内置',
    en: 'System Built-in',
    pu: 'Integrado ao Sistema'
  },
  isDefault: {
    zh: '默认',
    en: 'Default',
    pu: 'Padrão'
  },
  yes: {
    zh: '是',
    en: 'Yes',
    pu: 'Sim'
  },
  no: {
    zh: '否',
    en: 'No',
    pu: 'Não'
  },
  dictLabel: {
    zh: '字典标签',
    en: 'Dictionary Label',
    pu: 'Rótulo do Dicionário'
  },
  multiLangConfig: {
    zh: '多语言配置',
    en: 'Multi-language Config',
    pu: 'Configuração Multilíngue'
  },
  zhLang: {
    zh: '中文',
    en: 'Chinese',
    pu: 'Chinês'
  },
  enLang: {
    zh: '英文',
    en: 'English',
    pu: 'Inglês'
  },
  puLang: {
    zh: '葡语',
    en: 'Portuguese',
    pu: 'Português'
  },
  sortOrder: {
    zh: '排序',
    en: 'Sort Order',
    pu: 'Ordem'
  },
  dictDataManage: {
    zh: '字典数据管理',
    en: 'Dictionary Data Management',
    pu: 'Gerenciamento de Dados do Dicionário'
  },
  dictDataList: {
    zh: '字典数据列表',
    en: 'Dictionary Data List',
    pu: 'Lista de Dados do Dicionário'
  },
  confirmDelete: {
    zh: '确定删除该字典类型吗？删除后相关数据将不可恢复。',
    en: 'Are you sure to delete this dictionary type? Related data cannot be recovered.',
    pu: 'Tem certeza de que deseja excluir este tipo de dicionário? Os dados relacionados não podem ser recuperados.'
  },
  confirmDeleteData: {
    zh: '确定删除该字典数据吗？',
    en: 'Are you sure to delete this dictionary data?',
    pu: 'Tem certeza de que deseja excluir estes dados do dicionário?'
  },
  systemCannotDelete: {
    zh: '系统内置字典类型不允许删除',
    en: 'System built-in dictionary type cannot be deleted',
    pu: 'O tipo de dicionário integrado ao sistema não pode ser excluído'
  },
  systemDataCannotDelete: {
    zh: '系统内置字典数据不允许删除',
    en: 'System built-in dictionary data cannot be deleted',
    pu: 'Os dados do dicionário integrados ao sistema não podem ser excluídos'
  },
  dictTypeCannotModify: {
    zh: '字典类型Key不允许修改',
    en: 'Dictionary type key cannot be modified',
    pu: 'A chave do tipo de dicionário não pode ser modificada'
  },
  dictTypeKeyFormat: {
    zh: '请输入小写字母和下划线格式，如：sys_user_sex',
    en: 'Please use lowercase letters and underscores, e.g.: sys_user_sex',
    pu: 'Use letras minúsculas e sublinhados, ex: sys_user_sex'
  },
  dictValueReadonly: {
    zh: '系统内置项的字典值不可修改',
    en: 'Dictionary value of system built-in item cannot be modified',
    pu: 'O valor do dicionário do item integrado ao sistema não pode ser modificado'
  },
  dictTypeListTitle: {
    zh: '字典类型管理',
    en: 'Dictionary Type Management',
    pu: 'Gerenciamento de Tipo de Dicionário'
  },
  manageData: {
    zh: '管理数据',
    en: 'Manage Data',
    pu: 'Gerenciar Dados'
  },
  backToList: {
    zh: '返回列表',
    en: 'Back to List',
    pu: 'Voltar à Lista'
  }
};
export { dictionary };
